import { createSelector } from "reselect";
import { MAPS } from "../../Helpers/maps";
import { log } from "../../Helpers/logger";

export const getMap = position => MAPS[position?.mapId];
export const getX = position => position?.x;
export const getY = position => position?.y;

export const getZones = createSelector(
    getMap,
    map => map?.zones || {},
);

// Returns null if the position resolves to no zone (out-of-bounds, missing
// zone definition). Consumers should use optional chaining or fall back.
export const getZone = createSelector(
    [getZones, getX, getY],
    (zones, x, y) => {
        const zone = zones['map' + x + y];
        if (!zone) {
            log.saga.warn(`Zone not found at x:${x}, y:${y}`);
            return null;
        }
        return zone;
    }
)

export const getZoneName = createSelector(
    getZone,
    zone => zone?.name || 'Zone inconnue'
)

export const getZoneFightThreshold = createSelector(
    getZone,
    zone => zone?.fightThreshold ?? 100  // 100 = effectively no fight
)

export const getZoneMonsterIdList = createSelector(
    getZone,
    zone => zone?.monsterIdList || []
)